<template>
  <div >
    <multiselect class="multiselector"
      v-model="selectedOption"
      :options="listOptions"
      :label="listLabel"
      :track-by="listValue"
      placeholder=""
      :clear-on-select="true"
      :show-labels="false"
      :multiple="false"
    />
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'

  export default {
    name: 'person-select',
    components: {
      Multiselect,
    },
    data () {
      console.log(JSON.parse(this.options));
      return {
        selectedOption: this.value ? this.value : null,
        listOptions: JSON.parse(this.options),
        listLabel: this.labelName ? this.labelName : 'name',
        listValue: this.valueName ? this.valueName : 'id',
      }
    },
    computed: {
    },
    methods: {
      setNewValue(newValue){
        var el = document.getElementById(this.hiddenElement)
        if (el){
          el.value = newValue[this.$data.listValue]
        }
      }
    },
    created () {
      let wantedData = this.filtered_person_data ? this.filtered_person_data : JSON.parse(this.options)
      console.log("wantedData", wantedData)

      let count = 1

      this.listOptions = !this.filtered_person_data ? [] : wantedData.map(person => {
        let data = {
          id: person.id,
          tracking_id: count,
          training_center_id: person.training_center_id,
          training_center_group_id: person.training_center_group_id,
          name: person.name,
        }

        count++

        return data
      })

      console.log(this.listOptions)
    },
    props: {
      options: {
        type: String,
        required: true,
      },
      value: {
        type: String,
        required: false,
      },
      labelName: {
        type: String,
        required: false,
      },
      valueName: {
        type: String,
        required: false,
      },
      hiddenElement: {
        type: String,
        required: true,
      },
      filtered_person_data: {
        type: Array,
        required: false,
      }
    },
    watch: {
      selectedOption (newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.setNewValue(newVal)
        }
      },
    },
  }
</script>

<style lang="scss">
  .multiselector {
    min-width: 14rem;
    max-width: 100%;
  }
</style>
